/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-01-08 11:25:54
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:29:41
 * @FilePath: \h5-lcjc-formula\src\utils\category\Endocrine.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 内分泌学 */

/** 对应的标题 */
const categoryMap = {
  HSCCF: '高血糖时钠浓度校正公式',
  MSDC: '代谢综合征诊断标准（IDF/AHA/CDS）',
  PancreaticCancer_TNM: '胰腺癌TNM分期',
  GDM: '妊娠期糖尿病（GDM）诊断标准',
  DR: '糖尿病视网膜病变（DR）分期',
  Plasma_Volume: '血浆容量',
  Bicarbonate_deficiency: '碳酸氢盐缺乏',
  HOMA_IR: '胰岛素抵抗指数（HOMA-IR）',
  DiabeticFeet: '糖尿病足Wagner分级法',
  SexualDevelopment: '性发育Tanner分期',
  Congenital_HYP: '先天性甲状腺功能减退症的血清甲状腺激素诊断标准',
  GravesOCC: 'Graves眼病分级标准',
  ClassificationOfGoiter: '甲状腺肿分级',
  DiagnosticCriteriaForDM: '糖尿病诊断标准',
  GDMWhite: '妊娠期糖尿病（GDM）White分类',
  GravesCAS: 'Graves眼病CAS评分',
  HbA1c: '糖化血红蛋白（HbA1c）换算',
  RiskAssessment: '甲亢复发风险评估',
  SMBG: '血糖自我监测（SMBG）',
  Microalbuminuria: '微量白蛋白尿',
  HHS: '高渗性高血糖状态（HHS）的实验室诊断',
  IdealWeight_dailyEnergy: '每日能量需要量',
  Type_2_Diabetes_Control_Goals: '中国2型糖尿病控制目标',
  Pharmacological_treatment_of_type_2_diabetes: '2型糖尿病的治疗药物',
  Glycosylated_hemoglobin_target: '不同人群的糖化血红蛋白目标',
  Oral_glucose_tolerance_test: '75克口服葡萄糖耐量试验（ogtt）',
  Physical_Activity_Schedule_for_People_with_Diabetes: '糖尿病患者的体育活动计划表',
  Alanine: '丙氨酸（Ala）',
  Acetone: '丙酮',
  Human_Epididymis_Protein_four: '人附睾蛋白4（HE4）',
  Human_Growth_Hormone: '人类生长激素（HGH）',
  Human_Chorionic_Gonadotropin: '人绒毛膜促性腺激素（HCG）',
  Lactic_Acid: '乳酸',
  Calcitonin: '降钙素',
  Macroprolactin: '巨泌乳素',
  Dehydroepiandrosterone_Sulfate: '硫酸脱氢表雄酮（DHEA-S）',
  Anti_Mullerian_Hormone: '抗苗勒氏管激素（AMH）',
  FT3: '游离三碘甲状腺原氨酸',
  adrenocorticotropic_hormone: '促肾上腺皮质激素（ACTH）',
  Prolactin: '催乳素（PRL）',
  Calcium: '钙',
  Leucine: '亮氨酸（Leu）',
  Tyrosine: '酪氨酸（Tyr）',
  Glucose: '葡萄糖',
  Prostate_Specific_Antigen: '前列腺特异性抗原（PSA）',
  parathyroid_hormone: '甲状旁腺激素（PTH）',
  Thyroglobulin: '甲状腺球蛋白（Tg）',
  Anti_Thyroglobulin_Antibodies: '甲状腺球蛋白抗体（Anti-Tg）',
  Thyroid_Uptake: '甲状腺摄取',
  Total_Thyroxine: '甲状腺素（TT4）',
  Aldosterone: '醛固酮',
  Fructosamine: '果糖胺',
  Thyroxine_binding_Globulin: '甲状腺素结合球蛋白（TBG）',
  Potassium: '钾（K）',
  p_Hydroxybutyrate: 'β-羟丁酸',
  TSHR_antibodies: 'TSH受体抗体（Anti-TSHR）',
  Thyroid_Stimulating_Hormone: '促甲状腺激素（TSH）',
  C_Peptide: 'C肽',
  '17_α_hydroxy_progesterone': '17-羟孕酮',
  FT4: '游离甲状腺素（FT4）',
  IGF_1: '胰岛素样生长因子1',
  Androstenedione: '雄烯二酮',
  IGFBP_3: '胰岛素样生长因子结合蛋白3',
  ACAC: '乙酰乙酸（乙酰乙酸盐）',
  Insulin_Unit_Conversion: '胰岛素',
  Triiodothyronine: '总三碘甲状腺原氨酸（T3）',
  Retinol: '视黄醇（维生素A）',
  Serine: '丝氨酸',
  Calcitriol: '1,25-二羟基维生素D3（骨化三醇）',
  Glucagon: '胰高血糖素'
}
/** 对应的描述 */
const categoryDescMap = {
  HSCCF: '',
  MSDC: '机体代谢状态评价工具',
  PancreaticCancer_TNM: '评估胰腺癌患者病情进展',
  GDM: '',
  DR: '评估DR病变程度',
  Plasma_Volume: '用于血浆置换疗法',
  Bicarbonate_deficiency: '估计碳酸氢盐丢失量',
  HOMA_IR: '胰岛素抵抗的稳态模型评估',
  DiabeticFeet: '评估糖尿病足严重程度',
  SexualDevelopment: '评估性成熟度',
  Congenital_HYP: '基于甲状腺功能血清学检查',
  GravesOCC: '评估Graves眼病严重程度',
  ClassificationOfGoiter: '评估甲状腺肿大的程度',
  DiagnosticCriteriaForDM: 'ADA/WHO标准',
  GDMWhite: '评估GDM严重程度',
  GravesCAS: '评估Graves眼病的活动度',
  HbA1c: 'HbA1c与平均血糖的换算',
  RiskAssessment: '甲亢复发可能性',
  SMBG: '患者血糖监测方案',
  Microalbuminuria: '白蛋白肌酐比',
  HHS: '糖尿病严重急性并发症之一',
  IdealWeight_dailyEnergy: '针对成人肥胖患者'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Endocrine.js